import { render, staticRenderFns } from "./AuctionManagement.vue?vue&type=template&id=21c2e0a1"
import script from "./AuctionManagement.vue?vue&type=script&lang=js"
export * from "./AuctionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports